<template>
  <h3>Major Sponsor</h3>
  <div>
    <a href="http://www.embo.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/embo.png"
        alt="EMBO"
        title="EMBO" />
      <img v-else src="./img/embo-darkMode.png" alt="EMBO" title="EMBO" />
    </a>
  </div>
  <h4>Event Sponsors</h4>
  <div>
    <a href="http://www.autodesk.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
      <img
        v-else
        src="./img/Autodesk-darkMode.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
    </a>
    <a href="http://vsg3d.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/FEI.png" alt="FEI Visualization Sciences Group" title="FEI Visualization Sciences Group" />
      <img v-else src="./img/FEI-darkMode.png" alt="FEI Visualization Sciences Group" title="FEI Visualization Sciences Group" />
    </a>
    <a href="http://www.nvidia.com/" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/nvidia.svg" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/nvidia-darkMode.svg" alt="NVIDIA" title="NVIDIA" />
    </a>
    <a href="http://its.unimelb.edu.au/research" rel="nofollow">
      <img src="./img/Uni_Melbourne.png" alt="The University of Melbourne" title="The University of Melbourne" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <p>
    If you are interested in contributing to the VIZBI conference as a sponsor, or in the
    possibility of organizing a
    <a href="/2014/Pre-event_Workshop_Form.pdf">pre-conference workshop</a>, please see the
    <a href="/2014/VIZBI_Sponsorship_Form_2014.pdf">EMBL Sponsorship brochure</a> for information
    and pricing, or get in contact with VIZBI chairs: <Email to="vizbi-contact" />.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.autodesk {
  max-height: calc(3.3rem * 0.6);
}
</style>
